import React from 'react';
import { AuthProvider } from './context/AuthContext';
import { Routes, Route, useLocation } from 'react-router-dom';
import Login from './pages/login/login';
import TimeTracker from './pages/time-tracker/time-tracker';
import ProjectsList from './pages/projects-list/projects-list';
import FeatureSelection from './pages/feature-selection/feature-selection';
import Header from './components/header/header';
import RevenueForecast from './pages/revenue-forecast/revenue-forecast';
import UtilizationDashboard from './pages/utilization-dashboard/utilization-dashboard';
import ComponentPage from './pages/components-page/components-page';
import CompanyList from './pages/companies/company-list';
import ContactList from './pages/contacts/contact-list';
import ProtectedRoute from './components/ProtectedRoute';
import AdminList from './pages/admin-console/admin-lists';
import { useAppSelector } from './store/hooks';
import { isSomething } from './utils/utils';
import NotificaionsWrapper from './components/notification/notification-wrapper';

function App() {
  const location = useLocation(); // Get the current location

  const notifications = useAppSelector((state) => state.UI.notifications);
  console.log('notifications', notifications);

  return (
    <div>
      <AuthProvider>
        {location.pathname !== '/' && <Header />}
        {isSomething(notifications) && <NotificaionsWrapper />}

        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/components" element={<ProtectedRoute element={<ComponentPage />} />} />
          <Route
            path="dashboards/user-dashboard/"
            element={<ProtectedRoute element={<FeatureSelection />} />}
          />
          <Route path="/admin-console/*" element={<ProtectedRoute element={<AdminList />} />} />
          <Route path="/projectsview/*" element={<ProtectedRoute element={<ProjectsList />} />} />
          <Route path="/companiesview/*" element={<ProtectedRoute element={<CompanyList />} />} />
          <Route path="/contactsview/*" element={<ProtectedRoute element={<ContactList />} />} />
          <Route path="/time-tracker/*" element={<ProtectedRoute element={<TimeTracker />} />} />
          <Route
            path="/dashboards/revenue-forecast"
            element={<ProtectedRoute element={<RevenueForecast />} />}
          />
          <Route
            path="/dashboards/utilization-dashboard/"
            element={<ProtectedRoute element={<UtilizationDashboard />} />}
          />
        </Routes>
      </AuthProvider>
    </div>
  );
}

export default App;
